import React from "react";
import { View, Pressable } from "react-native";
import { scale, verticalScale } from "@utils/scale";
import Text from "@components/AppText";

export class TabButton extends React.Component {
  render() {
    return (
      <Pressable
        {...this.props}
        style={{
          backgroundColor: this.props.isSelected
            ? "rgba(228, 0, 70, 0.1)"
            : "#E5E5E5",
          width: scale(160),
          height: verticalScale(40),
          borderWidth: 1,
          borderRadius: 6,
          borderColor: this.props.isSelected ? "#E40046" : "rgba(0, 0, 0, 0.2)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Text
          mukta
          style={{
            fontSize: scale(16),
            color: this.props.isSelected ? "#E40046" : "rgba(0, 0, 0, 0.86)",
          }}
        >
          {this.props.title}
        </Text>
      </Pressable>
    );
  }
}
